import $http from '@/libs/axios'

export default class MultiPosterApi {
  static async process(data: any) {
    return (await $http.post('multi-poster/process', data)).data
  }

  static async list(params: any = {}) {
    return (await $http.get('multi-poster', { params })).data
  }
}
